import React from 'react';
import PropTypes from 'prop-types';
import {
  visitStatues,
} from 'constants/service-plans';
import GenericTable from 'components/ui-kit/generic-table';
import { formatDateSpan } from 'helpers/datetime.helper';
import * as S from '../../styles';

export default function VisitsBlock({ visits }) {
  // GenericTable hands the whole row through as the third argument, which is what makes the closing date
  // reachable here: a visit is a job, so it can run past the day it starts on.
  const visitDateCell = (value, index, visit) => (
    <S.Cell key={index}>
      {formatDateSpan(value, visit?.scheduledEndTime)}
    </S.Cell>
  );

  const visitStatusCell = (value, index) => (
    <S.Cell key={index}>
      {visitStatues[value]}
    </S.Cell>
  );

  const visitColumns = [
    { name: 'description', label: 'Visit' },
    { name: 'invoiceNumber', label: 'Invoice #' },
    { name: 'scheduledStartTime', label: 'Date', component: visitDateCell },
    { name: 'appointmentStatus', label: 'Status', component: visitStatusCell },
  ];

  return (
    <>
      <S.Separator />
      <S.SubTitleSmall>List of Visits:</S.SubTitleSmall>
      <S.Table>
        <GenericTable
          // Sorted on a copy with a real two-argument comparator. The previous
          // `visits.sort((item) => item.scheduledStartTime)` took one argument and returned a date, which
          // coerces to NaN for every pair - so the order was whatever the engine's sort happened to
          // produce, and it mutated the prop in place while doing it.
          items={[...visits].sort(
            (a, b) => new Date(a.scheduledStartTime) - new Date(b.scheduledStartTime),
          )}
          columns={visitColumns}
        />
      </S.Table>
    </>
  );
}

VisitsBlock.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  visits: PropTypes.arrayOf(PropTypes.object).isRequired,
};
